import { checkPointServices } from '../../helpers/services/checkPoint.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, ddlHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const CHECK_POINT_MODULE = 'checkPoint';

// define action 
export const GET_ALL_CHECK_POINTS = 'getAllCheckPoints';
export const GET_CHECK_POINT = 'getCheckPoint';
export const UPDATE_CHECK_POINT = 'updateCheckPoint';
export const CREATE_CHECK_POINT = 'createCheckPoint';
export const CLONE_CHECK_POINT = 'cloneCheckPoint';
export const UPDATE_CHECK_POINT_STATUS = 'updateCheckPointStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_CHECK_POINTS_REQUEST = "getAllCheckPoints";
const GET_CHECK_POINT_REQUEST = "getCheckPoint";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CHECK_POINTS]({ commit }, { filter }) {
        checkPointServices
            .getAllCheckPoints(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CHECK_POINTS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },
    async [CLONE_CHECK_POINT]({ dispatch }, { filter, data }) {
       await checkPointServices
            .cloneCheckPoint(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t('message.cloneCheckPointSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CHECK_POINTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_CHECK_POINT]({ commit }, { id }) {
        await checkPointServices
            .getCheckPoint(id)
            .then(
                (result) => {
                    commit(GET_CHECK_POINT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CHECK_POINT]({ commit }, { data }) {
        commit(REQUEST)
        checkPointServices
            .updateCheckPoint(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.checkPoint')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_CHECK_POINT]({ commit }, { data }) {
        commit(REQUEST)
        checkPointServices
            .createCheckPoint(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.checkPoint')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CHECK_POINT_STATUS]({ dispatch }, { filter, data }) {
        checkPointServices
            .updateCheckPointStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CHECK_POINTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Check-point-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { processing: true, update: true, create: true };
    },
    [GET_ALL_CHECK_POINTS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                localeName: o.locale_name,
                mediaUrl: o.media_url,
                version: o.version,
                description: o.description,
                answerTypeID: o.answer_type_id,
                remark: o.remark,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time),
                service: o.service,
                parentCheckPoint: o.parent_check_point,
                subCheckPoint: o.sub_check_point,
                template: o.template,
                answer: o.answer,
            }
        })
    },
    [GET_CHECK_POINT_REQUEST](state, data) {
        let o = data.data

        const languages = ddlHelper.getLanguages();
        const answerTypes = ddlHelper.getAnswerTypes();

        var names = null;
        var type = null;
        var answers = null;

        if (o.locale_name != null) {
            names = [];
            Object.keys(o.locale_name.text).forEach(key => {
                names.push({ language: languages.find(lang => lang.code === key), name: o.locale_name.text[key] });
            });
        }
        else {
            names = []
        }

        if (o.answer_type_id != null) {
            type = {
                code: answerTypes.find(type => type.code === o.answer_type_id).code,
                name: answerTypes.find(type => type.code === o.answer_type_id).name
            };
            // type = [];
            // type.push({ code: answerTypes.find(type => type.code === o.answer_type_id).code, name: answerTypes.find(type => type.code === o.answer_type_id).name, });
        }

        answers = o.answer.map((data) => {
            var answerNames = null;
            var answer = null;
            if (data.locale_name != null) {
                answerNames = [];
                Object.keys(data.locale_name.text).forEach(key => {
                    answerNames.push({ language: languages.find(lang => lang.code === key), name: o.locale_name.text[key] });
                });
            }
            else {
                answerNames = []
            }

            answer =
            {
                labelID: data.label != null ? {
                    value: data.label.uuid,
                    text: data.label.text
                } : '',
                uuid: data.uuid,
                isActive: data.is_active,
                description: data.description,
                version: data.version,
                names: answerNames
            }

            return answer;
        });

        state.details = {
            uuid: o.uuid,
            name: o.name,
            names: names,
            localeName: o.locale_name,
            image: o.media_url,
            version: o.version,
            description: o.description,
            answerTypeID: type,
            remark: o.remark,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time),
            service: o.service,
            serviceID: o.service != null ? {
                value: o.service.uuid,
                text: o.service.name
            } : '',
            checkPointID: o.parent_check_point != null ? {
                value: o.parent_check_point.uuid,
                text: o.parent_check_point.name
            } : '',
            parentCheckPoint: o.parent_check_point,
            subCheckPoint: o.sub_check_point,
            template: o.template,
            answer: o.answer,
            answers: answers,
            newAnswers: []
        }
    }
}


